import { Box, Stack, Typography } from "@mui/material";
import PaypointImage from "Assets/Images/Images/moone-paypoint.svg";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Customer.Pay.ManualEntry;

// The tap-your-phone half of the send-payment screen. Grows to fill the space
// above the manual-entry paper, so it reads as the primary action with typing
// the ID as the fallback below it. Phone-only — the caller decides that.
export const NfcPrompt = () => {
  const { t } = useResource();

  return (
    <Stack flex={1} gap={2} alignItems="center" justifyContent="center">
      <Stack gap={0.5} alignItems="center" textAlign="center">
        <Typography fontSize={16} fontWeight={600} color="text.primary">
          {t(RESOURCES.NfcTitle)}
        </Typography>
        <Typography fontSize="0.875rem" color="text.secondary">
          {t(RESOURCES.NfcSubtitle)}
        </Typography>
      </Stack>
      <Box
        component="img"
        src={PaypointImage}
        alt=""
        sx={{ width: "100%", maxWidth: 200, objectFit: "contain" }}
      />
    </Stack>
  );
};
